import React, { useEffect, useState } from "react";
import classes from "./TxnFilter.module.css";
import ButtonTriangle from "../../../../../assets/bthTriangle.svg";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { useForm, Controller } from "react-hook-form";
import { Box, CircularProgress } from "@mui/material";
import AutocompleteForm from "../../../../../components/common/autuCompleteForm";
import { errorMessages } from "../../../../../components/utilities/formValidation";
import DatePickerForm from "../../../../../components/common/datePickerForm";
import { styled, Button } from "@mui/material";
import { useSelector } from "react-redux";
import { convertDate } from "../../../../../components/utilities/convertDate";


const statusOptions = [
  { value: "1", label: "Active" },
  { value: "4", label: "In-Active" },
  { value: "3", label: "Block" },
  { value: "5", label: "Rejected" },
];

const statusOptionsTwo = [
  { value: "1", label: "Active" },
  { value: "4", label: "In-Active" },
];

const defaultFilterData = {
    accNo: "",
    fromDt: "",
    toDt: "",
};

const CustFilterModal = ({
  show,
  handleClose,
  filterData,
  handleReset,
  text,
  accountList,
  getTransactionList,
  setFilterData,
  setSelectedAccountName,
  selectedAccountName

}) => {
    const {
        control,
        handleSubmit,
        setValue,
        getValues,
        register,
        watch,
        reset,
        formState: { isSubmitting, errors },
    } = useForm({
        defaultValues: defaultFilterData,
        mode: "onChange",
    });
    
   const { error, isAuthenticated, menu, userRole, sessionId, user } = useSelector((state) => state.auth);


  const [selectedTab, setSelectedTab] = useState("Account No.");

  const handleTabChange = (e, tabName) => {
    e.preventDefault();
    setSelectedTab(tabName);
  };

  const accNo = watch("accNo");
   useEffect(() => {
        if (accNo) {
            const account = accountList.find(
                (acc) => acc.value === watch("accNo").value
            );
            if (account) {
                setSelectedAccountName(account.name);
                setValue("acctype", account.acctype);
                setValue("accName", account.name); // Optional: keep form state in sync
            }
        }
    }, [watch("accNo"), accountList]);

  // const formatDate = (dateStr) => {
  //   if (!dateStr) return "";
  //   const [year, month, day] = dateStr.split("-");
  //   return `${day}-${month}-${year}`;
  // };

  const [loading, setLoading] = useState(false);
  const loggedInUserName = sessionStorage.getItem("username");
  const dynamicStatus = text === "AddUser" ? statusOptionsTwo : statusOptions;


const handleResetFilter = () => {
    reset(defaultFilterData);
    setFilterData(defaultFilterData);
};
  const modifyStructure = (response) => {
    return (
      response &&
      response?.map((customer, index) => ({
        ...customer,
        id: index + 1,
        address:
          customer.address1 + ", " + customer.address2 + ", " + customer.address3,
      }))
    );
  };
  const ColorButton = styled(Button)(({ theme }) => ({
        // color: "#FFFFFF",
        color: "#000000",
        // backgroundColor: "#F84B67",
        // backgroundColor: "#323232",
        backgroundColor: "#fff",
        border: "1px solid #000",
        borderRadius: "8px",
        paddingLeft: "15px",
        paddingRight: "15px",
        width: "183px",
        height: "38px",
        "&:hover": {
            background: "#808080",
            color: "white",
        },
    }));
     const ColorButton1 = styled(Button)(({ theme }) => ({
        color: "#fff",
        // backgroundColor: "#F84B67",
        backgroundColor: "var(--button-color)",
        border: "1px solid #CCC",
        borderRadius: "8px",
        paddingLeft: "15px",
        paddingRight: "15px",
        width: "183px",
        height: "38px",
        "&:hover": {
            background: "var(--button-hover-color)",
            color: "white",
        },
    }));
      const onSubmit = async (data) => {
    // setIsloading(true);
   
      const payload = {
         custNo: user?.userId,
         sessionId: user?.sessionId,
         accNo:data?.accNo?.value,
         fromDt: convertDate(data.fromDt, 1)
                ? convertDate(data.fromDt, 1)
                : convertDate(new Date(), 1),
            toDt: convertDate(data.toDt, 1)
                ? convertDate(data.toDt, 1)
                : convertDate(new Date(), 1),

      };
    const displayFilterData = {
        accNo: data?.accNo?.value || "",
        fromDt: convertDate(data.fromDt, 1)
                ? convertDate(data.fromDt, 1)
                : "",
            toDt: convertDate(data.toDt, 1)
                ? convertDate(data.toDt, 1)
                : "",
    };

    setFilterData(displayFilterData);
    getTransactionList(1, payload);


  };
  return (
    show && (
      <div className={classes.modalOverlay}>
        <div className={classes.modalDialog}>
          <div className={classes.modalContent}>
            <div className={classes.modalHeader}>
              <h5 className={classes.modalTitle}>Filter</h5>
              <HighlightOffIcon onClick={handleClose} className={classes.closeIcon} />
            </div>

            <Box
            onSubmit={handleSubmit(onSubmit)}
            component="form">
              <div className={classes.formWrapper}>
                <div className={classes.tabContainer}>
                  <ul className={classes.tabList}>
                    {["Account No.","Select Date"].map((tab) => (
                      <div className={classes.tabItem} key={tab}>
                        <li
                          className={`${classes.tabButton} ${
                            selectedTab === tab ? classes.tabActive : ""
                          }`}
                        >
                          <button
                            className={`${classes.tabInnerButton} ${
                              selectedTab === tab ? classes.tabTextActive : ""
                            }`}
                            onClick={(e) => handleTabChange(e, tab)}
                          >
                            {tab}
                          </button>
                        </li>
                        {selectedTab === tab && (
                          <img
                            src={ButtonTriangle}
                            alt="tri"
                            className={classes.triangleIcon}
                          />
                        )}
                      </div>
                    ))}
                  </ul>

                  <div className={classes.tabContent}>
                    {selectedTab === "Account No." && (
                     <div>
                                        <div className={classes.frowtextaff}>
                                            Account Number<sup className={classes.required}>*</sup>
                                        </div>
                                        <AutocompleteForm
                                            controlerProps={{
                                                control: control,
                                                name: "accNo",
                                            }}
                                            TextFieldProps={{
                                                placeholder: "Select Account Number",
                                                onKeyDown: (event) => {
                                                    // const regex = /^[0-9]*$/;
                                                    const regex = /^[a-zA-Z0-9]*$/;
                                                    const isBackspace = event.keyCode === 8;
                                                    const isValidInput = regex.test(event.key);

                                                    const currentInputValue = event.target.value;

                                                    // Maximum length constraint
                                                    const maxLength = 32; // Set your max length here
                                                    const isMaxLengthReached =
                                                        currentInputValue.length >= maxLength;

                                                    if (
                                                        (!isValidInput && !isBackspace) ||
                                                        (isMaxLengthReached && !isBackspace)
                                                    ) {
                                                        event.preventDefault();
                                                    }
                                                },
                                            }}
                                            rules={{
                                                required:
                                                    "Account Number " +
                                                    errorMessages.error_autocomplete_message,

                                                // maxLength: {
                                                //   value: 32, // Set your max length here
                                                //   message:
                                                //     "Account Number must be no more than 10 digits long",
                                                // },
                                            }}
                                            data={accountList}
                                            required={true}
                                        />
                                        {/* <div className={classes.availablebalance}>Available Balance: <span className={classes.balace}>₹ {accountBalance?.accBal}</span></div> */}
                                    </div>
                    )}

                

                    {selectedTab === "Select Date" && (
                      <>
                       <div>
                                        <div className={classes.frowtextaff}>
                                            From Date<sup className={classes.required}>*</sup>
                                        </div>

                                        <DatePickerForm
                                            controlerProps={{
                                                control: control,
                                                name: "fromDt",
                                            }}
                                            TextFieldProps={{
                                                fullWidth: true,
                                            }}
                                            DatePickerProps={{
                                                // label: "From Date",
                                                fullWidth: true,
                                                maxDate: new Date(),
                                            }}
                                            // rules={{
                                            //     required:
                                            //       "From Date " + errorMessages.error_autocomplete_message,
                                            //   }}
                                            required={false}
                                        />
                                    </div>

                                     <div>
                                        <div className={classes.frowtextaff}>
                                            To Date<sup className={classes.required}>*</sup>
                                        </div>
                                        <DatePickerForm
                                            controlerProps={{
                                                control: control,
                                                name: "toDt",
                                            }}
                                            TextFieldProps={{
                                                fullWidth: true,
                                            }}
                                            DatePickerProps={{
                                                // label: "To Date",
                                                fullWidth: true,
                                                minDate: watch("fromDate"),
                                                maxDate: new Date(),
                                            }}
                                            // rules={{
                                            //     required:
                                            //       "To Date " + errorMessages.error_autocomplete_message,
                                            //   }}
                                            required={false}
                                        />
                                    </div>
                                    </>
                    )}
                  </div>
                </div>
                
              </div>

              <div className={classes.footer}>
                  <ColorButton variant="contained"
                  onClick={handleResetFilter}
                  >
                                        Reset
                                    </ColorButton>
                  <ColorButton1 variant="contained"
                //  onClick={() => getTransactionListView(1)}
                type="submit"
                  >
                                        Submit
                                    </ColorButton1>
              </div>
            </Box>
          </div>
        </div>
      </div>
    )
  );
};

export default CustFilterModal;
